import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import {
  getAgreementText,
  getClientAgreementSignture
} from 'features/OnboardingQuestions/ducks/OnboardingQuestionsActions';
import Breadcrumb from 'react-bootstrap/Breadcrumb';


class Agreement extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getAgreementText();
    this.props.getClientAgreementSignture(this.clientId);
  }

  render() {
    let {
      client,
      loadingClient,
      agreement,
      clientSignature,
      loadingAgreement
    } = this.props;

    if (loadingClient || loadingAgreement || loadingAgreement) {
      return(<Loader/>)
    }
    return (
      <div className="questionnaire-page">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}`}>
              {`${client?.first_name} ${client?.last_name}`}
            </Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}/onboardingQuestions`}>
              Onboarding Questions
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Client Agreement</Breadcrumb.Item>
          </Breadcrumb>
          <div className="page-title">
            <h4>Client Agreement</h4>
          </div>
          {clientSignature && agreement && Object.keys(agreement).length ? (
            <>
              <p>{agreement.title}</p>
              <div className="form-check agreement-text-checkbox">
                <label className="form-check-label">
                  <input type="checkbox" className="form-check-input" checked={true} disabled={true} />
                  <span>
                    <i className="far fa-square green-square"></i>
                      I, {`${client?.first_name} ${client?.last_name}`}, agree to the terms above
                  </span>
                </label>
              </div>

              <h3>Signature</h3>
              <img className="signature" src={clientSignature} alt="Signature" />
            </>
          ) : (
            <p>This Client didn't Responce to the Onboarding Questions yet!</p>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    agreement: state.OnboardingQuestionsReducer.agreement,
    loadingAgreement: state.OnboardingQuestionsReducer.loadingAgreement,
    clientSignature: state.OnboardingQuestionsReducer.clientSignature,
    loadingClientSignature: state.OnboardingQuestionsReducer.loadingClientSignature
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getAgreementText: () => dispatch(getAgreementText()),
    getClientAgreementSignture: clientId => dispatch(getClientAgreementSignture(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Agreement);
